import { render, staticRenderFns } from "./view.html?vue&type=template&id=524c33cd&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=524c33cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c33cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524c33cd')) {
      api.createRecord('524c33cd', component.options)
    } else {
      api.reload('524c33cd', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=524c33cd&scoped=true&", function () {
      api.rerender('524c33cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/partials/live_drop_box/index.vue"
export default component.exports